import { apiService } from './api.service';
import { Language, PageWithPermissions } from 'types/index';

export interface PageMenuItem {
  path: string;
  label: string;
  icon?: string;
}

export interface PageDetailsResponse {
  menuItems?: PageMenuItem[];
  [key: string]: any;
}

class SettingsService {
  async getPageDetails(): Promise<PageDetailsResponse> { 
    const response = await apiService.get<any>(`/Settings/Pages`);
    const payload = (response as any)?.data ?? response;
    if (payload && typeof payload === 'object') {
      return payload as PageDetailsResponse;
    }
    return { menuItems: [] } as PageDetailsResponse;
  }

  async getPagesWithPermissions(): Promise<PageWithPermissions[]> {
    const response = await apiService.get<PageWithPermissions[]>(`/Settings/PagesWithPermissions`);
    const payload = (response as any)?.data ?? response;
    if (Array.isArray(payload)) {
      return payload as PageWithPermissions[];
    }
    return [];
  }
}

export const settingsService = new SettingsService();
export default settingsService;


